const postQuicksight = {
  toastr: 'Added user',
  toastr1: ' has been successfully added',
  toastrError: 'Answer already registered',
  toastrError1: 'Enter another name'
};

export default postQuicksight;
